import { render, staticRenderFns } from "./TicketsIcon.vue?vue&type=template&id=74c655cc&scoped=true"
var script = {}
import style0 from "./TicketsIcon.vue?vue&type=style&index=0&id=74c655cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c655cc",
  null
  
)

export default component.exports